export const isExternalLink = url => {
  const linkUrl = url.startsWith('www') ? `http://${url}` : url;
  try {
    return !new URL(linkUrl).hostname.includes('.which.co.uk');
  } catch {
    return false;
  }
};